// Cloudflare Turnstile sitekey resolution (anti-abuse no intake anônimo, D-29).
// Padrão espelha config/escrow.ts: VITE_ no build, fallback dev explícito.
//
// O backend (turnstileGuard em apps/api) faz o siteverify REAL com o secret
// pareado (TURNSTILE_SECRET_KEY). Em dev o worker roda TEST_BYPASS e aceita
// qualquer token; aqui usamos a test sitekey PÚBLICA da Cloudflare para o
// widget renderizar sem conta provisionada. Produção EXIGE a sitekey real.

/**
 * Test sitekey pública oficial da Cloudflare — "always passes", widget visível.
 * https://developers.cloudflare.com/turnstile/troubleshooting/testing/
 * Pareada no backend com a secret TEST_BYPASS (paridade dev).
 */
export const TURNSTILE_TEST_SITEKEY = '1x00000000000000000000AA';

/**
 * Returns the Turnstile sitekey to render the widget with.
 *
 * Production: read from `VITE_TURNSTILE_SITEKEY` (set at build time). No
 * fallback — a sitekey ausente em prod é erro de configuração e o canal NÃO
 * deve subir sem anti-abuse.
 * Dev fallback: Cloudflare test sitekey (always passes), com warning alto.
 */
export function getTurnstileSitekey(): string {
  const fromEnv = import.meta.env.VITE_TURNSTILE_SITEKEY;
  if (typeof fromEnv === 'string' && fromEnv.length > 0) {
    return fromEnv;
  }

  if (import.meta.env.MODE === 'production') {
    throw new Error(
      '[turnstile] VITE_TURNSTILE_SITEKEY is required in production. ' +
        'Set it at build time once the Cloudflare Turnstile widget is provisioned.',
    );
  }

  // Dev-only fallback — test sitekey sempre passa (paridade backend TEST_BYPASS).
  console.warn(
    '[turnstile] DEV FALLBACK — using Cloudflare test sitekey (always passes). ' +
      'Set VITE_TURNSTILE_SITEKEY for real anti-abuse verification.',
  );
  return TURNSTILE_TEST_SITEKEY;
}
